var render, staticRenderFns
import script from "./Point.vue?vue&type=script&lang=js"
export * from "./Point.vue?vue&type=script&lang=js"
import style0 from "./Point.vue?vue&type=style&index=0&id=501d7e3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d7e3a",
  null
  
)

export default component.exports